// Func = limiting Scope for this file
var lastScrollTop = document.documentElement.scrollTop;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;
let documentHeight = document.documentElement.scrollHeight;
const spanContainer = document.querySelector('#notesContainer');
let pointStart = [];

let scrollParallaxH = [];
let lastScrollLeft = [];
let itemsWidth = 0;
let itemsContainer = []

let backgroundParallax = [];
let lastScrollY = [];

let swiperInit = false;
let allMediaSwiper =[];

let isScrolling = false;
let scrollIndex = [];

let lenisScroll = 0;
let marketingItemScroll = [];
let scrollEventMarketing = [];

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	
	
		// const lenis = new Lenis({
		// 	duration: 0.7,
		// 	smooth: true,
		// 	smoothTouch: false,
		// });
	
		// function raf(time) {
		// 	lenis.raf(time);
		// 	requestAnimationFrame(raf);
		// }
	
		// requestAnimationFrame(raf);

		// lenis.on('scroll', ({ scroll }) => {
			
		// 	lenisScroll = scroll; 
		// });
		
		// function scrollToPosition(y) {
		// 	lenis.scrollTo(y, {
		// 	  duration: 0.4, // Duration of the scroll
		// 	  easing: t => t, // Easing function
		// 	});
		// }
	

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	let cardItems = document.querySelectorAll('.card__item');

	if (cardItems.length > 0) {
		cardItems[0].classList.add('active');
	}
	
	cardItems.forEach(function(cardItem) {
		cardItem.addEventListener('mouseenter', function() {
			cardItems.forEach(function(item) {
				item.classList.remove('active');
			});
			cardItem.classList.add('active');
		});
	});

	if (document.querySelector('.nav-item-button')) {
		const navItemButton = document.querySelector('.nav-item-button');
		const postNavMobile = document.querySelector('.post-nav');
		navItemButton.addEventListener('click', () => {
			postNavMobile.classList.toggle('active');
		});
	
		const navLinks = document.querySelectorAll('.post-nav .nav-item a');
	
		navLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				if (postNavMobile.classList.contains('active')) {
					navItemButton.textContent = link.textContent;
					postNavMobile.classList.remove('active');
				}
			});
		});
	}

	const tabs = document.querySelectorAll('.tab');
    const contents = document.querySelectorAll('.menu__content');
	
	tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));
            tab.classList.add('active');
            const tag = tab.getAttribute('data-tag');
            const contentToActivate = document.querySelector(`.menu__content[data-tag="${tag}"]`);
            if (contentToActivate) {
                contentToActivate.classList.add('active');
            }
        });
    });
	
	if (tabs.length > 0) {
        tabs[0].click();
    }

	const experienceItems = document.querySelectorAll('.experiences__item');

    experienceItems.forEach((experienceItem) => {
        const parentTag = experienceItem.getAttribute('data-tag');
        const tabItems = experienceItem.querySelectorAll('.experiences__tabs .tab-item');

        tabItems.forEach((tabItem) => {
            if (tabItem.getAttribute('data-tag') === parentTag) {
                tabItem.classList.add('active');
            }
        });
    });

	function moveFirstParagraph() {
		const principalImage = document.querySelector('.intro-content__image--principal');
		if (principalImage) {
			const introContentText = document.querySelector('.intro-content__text');
			const content = document.querySelector('.intro-content__text .content');
			const firstParagraph = content ? content.querySelector('p') : null;
	
			if (introContentText && content && firstParagraph) {
				introContentText.insertBefore(firstParagraph, content);
			}
		}
	}
	
	moveFirstParagraph();

	// Menu Functionality
	let menuContent = document.getElementById("navigationBox");
	let header = document.getElementById("header");
	let menuBtn = document.querySelector("[data-show_nav]");
	let closeMenuBtn = document.querySelector("[data-close_nav]");

	//Open/CLose
	if(menuBtn){
		menuBtn.addEventListener('click', function (e) {
			menuBtn.classList.toggle("open");
			menuContent.classList.toggle("open");
			header.classList.toggle("menuOpen");
		});
	}
	if(closeMenuBtn){
		closeMenuBtn.addEventListener('click', function (e) {
			menuBtn.classList.remove("open");
			menuContent.classList.remove("open");
			header.classList.remove("menuOpen");
		});
	}

	// Form Functionality
	let headerBtn = document.querySelector(".headerForm");
	let homeForm = document.querySelector(".home-form");

	//Open/CLose
	if(headerBtn){
		headerBtn.addEventListener('click', function (e) {
			headerBtn.classList.toggle("open");
			homeForm.classList.toggle("open");
		});
	}

	const navItems = document.querySelectorAll('.inner ul li');
    navItems.forEach((item) => {
        const submenu = item.querySelector('.sub-sub-menu');
        const link = item.querySelector('a');

        if (submenu && link) {
            let firstClick = true;

            link.addEventListener('click', function(event) {
                if (firstClick) {
                    event.preventDefault();
                    submenu.classList.add('active');
                    firstClick = false;
                }
            });

            document.addEventListener('click', function(e) {
                if (!item.contains(e.target)) {
                    firstClick = true;
                    submenu.classList.remove('active');
                }
            });
        }
    });
	
	const DesktopNavItems = document.querySelectorAll('.privary-navigation ul li');
    DesktopNavItems.forEach((item) => {
        const submenu = item.querySelector('.submenu');
        const link = item.querySelector('a');

        if (submenu && link) {
            let firstClick = true;

            link.addEventListener('click', function(event) {
                if (firstClick) {
                    event.preventDefault();
                    submenu.classList.add('active');
                    firstClick = false;
                }
            });

            document.addEventListener('click', function(e) {
                if (!item.contains(e.target)) {
                    firstClick = true;
                    submenu.classList.remove('active');
                }
            });
        }
    });

	const subMenu = document.querySelector('.sub-menu');

    if (subMenu) {
        // Verifica si estamos en mobile (puedes ajustar el ancho según tus necesidades)
        if (window.innerWidth <= 768) {
            const ul = subMenu.querySelector('ul');
            const liItems = ul.querySelectorAll('li');
            
            // Crea el elemento <select>
            const select = document.createElement('select');
            select.classList.add('mobile-select');

			// Obtén la URL actual
            const currentUrl = window.location.href;

            // Agrega una opción por defecto
            const defaultOption = document.createElement('option');
            defaultOption.textContent = 'Select an option';
            defaultOption.disabled = true;
            defaultOption.selected = true;
            select.appendChild(defaultOption);

            // Itera sobre los <li> y crea opciones para el <select>
            liItems.forEach(li => {
                const link = li.querySelector('a');
                if (link) {
                    const option = document.createElement('option');
                    option.value = link.href;
                    option.textContent = link.textContent;

					if (link.href === currentUrl) {
                        option.selected = true;
                    }

                    select.appendChild(option);
                }
            });
            // Reemplaza el <ul> con el <select>
            ul.parentNode.replaceChild(select, ul);
            // Agrega un evento para redirigir al enlace seleccionado
            select.addEventListener('change', (e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const selectedValue = selectedOption.value; // URL del enlace
                if (selectedValue) {
                    window.location.href = selectedValue;
                }
            });
        }
    }
	
	if(document.querySelectorAll('[simple-observable]').length){
		let simpleObservables = new IntersectionObserver(entries => {
			entries.forEach(function (entry, index) {
				
				if (entry.isIntersecting) {
					entry.target.classList.add('on-viewport')
				} else {
					if(!entry.target.classList.contains('structure-block')){
						entry.target.classList.remove('on-viewport')
					}
				}
			})
		},
		{
		threshold : 0.99
		});
		document.querySelectorAll('[simple-observable]').forEach(function (element,index) {
			simpleObservables.observe(element);
		})
	}
	
	if(document.querySelectorAll('[simple-animate]').length){
		let reverseObservables = new IntersectionObserver(entries => {
			entries.forEach(function (entry, index) {
				
				if (entry.isIntersecting) {
					entry.target.classList.add('on-viewport')
				} else {
					entry.target.classList.remove('on-viewport')
				}
			})
		},
		{
			rootMargin : '0% 0px -20% 0px',
			threshold : 0
		});
		document.querySelectorAll('[simple-animate]').forEach(function (element,index) {
			reverseObservables.observe(element);
		})
	}

	if(document.querySelectorAll('[horizontal-container]').length){
		let reverseObservables = new IntersectionObserver(entries => {
			entries.forEach(function (entry, index) {
				
				if (entry.isIntersecting) {
					let movedHeight = document.querySelector('.carousel').querySelectorAll('.item') <= 3 ? (windowHeight * 0.04) : (windowHeight * 0.1);
					if(lastScrollTop > offset(entry.target).top){
						// console.log(entry.target.parentElement.offsetTop, offset(entry.target.parentElement).top)
						lenis.scrollTo(offset(entry.target.parentElement).top - movedHeight, { duration: 0.1 });
						setTimeout(() => {
							entry.target.querySelector('.carousel').setAttribute('style',`transform:translateX(0%)`);
							entry.target.querySelector('.carousel').dataset.x = 0;
						}, 2000);
							
					} else {
						// entry.target.parentElement.setAttribute('style',`height:${itemsWidth}px`);
						checkScroll(entry.target, index);
						entry.target.classList.add('on-viewport')
						entry.target.classList.add('visible')
					}
				} else {
					window.removeEventListener('scroll', scrollParallaxH[index])
					entry.target.classList.remove('on-viewport');
					if(lastScrollTop < offset(entry.target).top){
						
					}
					
				}
			})
		},
		{
		threshold : 0.95
		});
		document.querySelectorAll('[horizontal-container]').forEach(function (element,index) {
			reverseObservables.observe(element);
			itemsWidth = ((element.querySelector('.carousel').querySelectorAll('.item').length - 1) * 670) + 100;
			element.parentElement.setAttribute('style',`height:${itemsWidth}px`);
			itemsContainer[index] = offset(element).top;
		})
	}

	//work category observer
	if(document.querySelectorAll('.ob-image').length){

		let imageObservable = new IntersectionObserver(entries => {
			entries.forEach(function (entry, index) {
				
				if (entry.isIntersecting) {
					entry.target.classList.add('active');
					document.querySelector(`[data-image=${entry.target.dataset.target}]`).classList.add('active')
					document.querySelector(`[data-tab=${entry.target.dataset.target}]`).classList.add('active')
					// if(entry.target.dataset.index == document.querySelector('.js-cat-column').children.length - 1){
						
					// 	document.querySelector('.js-cat-column').classList.add('static');
					// }
				} else {
					entry.target.classList.remove('active');
					document.querySelector(`[data-image=${entry.target.dataset.target}]`).classList.remove('active')
					document.querySelector(`[data-tab=${entry.target.dataset.target}]`).classList.remove('active')
					// if(document.documentElement.scrollTop < lastScrollTop){
					// 	if(entry.target.dataset.index == document.querySelector('.js-cat-column').children.length - 1){
					// 		document.querySelector('.js-cat-column').classList.remove('static');
					// 	}
					// }
				}
			})
		},
		{
		rootMargin : '-50% 0px -45% 0px',
		threshold : 0
		});
		document.querySelectorAll('.ob-image').forEach(function (element,index) {
			imageObservable.observe(element);
			document.querySelector(`[data-tab=${element.dataset.target}]`).setAttribute('data-scroll',(offset(element).top - (100)));
		})
		
		document.querySelectorAll('.js-cat-tab').forEach(tab => {
			tab.addEventListener('click', function(){
				scrollToPosition(parseInt(tab.dataset.scroll));
			})
		});

		let lastImageObserver = new IntersectionObserver(entries => {
			entries.forEach(function (entry, index) {
				
				if (entry.isIntersecting) {

					entry.target.classList.add('active');
					document.querySelector(`[data-image=${entry.target.dataset.target}]`).classList.add('active')
					document.querySelector(`[data-tab=${entry.target.dataset.target}]`).classList.add('active')
					
				} else {
					entry.target.classList.remove('active');
					document.querySelector(`[data-image=${entry.target.dataset.target}]`).classList.remove('active')
					document.querySelector(`[data-tab=${entry.target.dataset.target}]`).classList.remove('active')
					
				}
			})
		},
		{
			rootMargin : '-55% 0px -45% 0px',
			threshold : 0
		});
		lastImageObserver.observe(document.querySelector('.ob-image-last'))
		document.querySelector(`[data-tab=${document.querySelector('.ob-image-last').dataset.target}]`).setAttribute('data-scroll',(offset(document.querySelector('.ob-image-last')).top - (220)));
		//
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	/*****************************************************
	OBSERVER TO ADD PARALLAX EFFECT
	/*****************************************************/
	var scrollParallax = [];
	var scrolled = 0;
	
	// screen height
	var v_height =
	window.innerHeight ||
	document.documentElement.clientHeight ||
	document.body.clientHeight;
	
	function doParallax(elm) {
		let boundes = elm.dataset.parallax.split(","); // get it from html
		//get distance in positive value
		let distance = Math.abs(boundes[0] - boundes[1]);
		if (boundes[0] > boundes[1]) {
			//get distance in negative value (to do the scroll inverse)
			distance = distance * -1;
		}
		//Equivalent distance using screen height + element height
		const unit_scroll = distance / (v_height + elm.offsetHeight);
		let temp = 0;
		
		let topElement = 0;
		let element = elm;
		
		let id_elem = elm.dataset.parallaxid;
		
		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element);
		
		let parallaxFunction = function () {
			//Obtain the distance between top screen and document top 0
			scrolled = document.documentElement.scrollTop || window.pageYOffset;
			//Distance of bottom page to top of the element
			let relative_distance = scrolled + v_height - topElement;
			//transpoling data to move the parallax element relative to the scroll of all the screen
			temp = unit_scroll * relative_distance + parseInt(boundes[0]);
			//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
			elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
		};
		
		scrollParallax[id_elem] = parallaxFunction;
		
		window.addEventListener("scroll", scrollParallax[id_elem]);
		}
		
		let observers_parallax = document.querySelectorAll(".js-parallax-element");
		
		if (observers_parallax) {
		let options_parallax = {
			root: null, // relative to document viewport
			rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0, // visible amount of item shown in relation to root
		};
		
		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				doParallax(entry.target);
			} else {
				let id_elem = entry.target.dataset.parallaxid;
				window.removeEventListener("scroll", scrollParallax[id_elem]);
			}
			});
		}
		
		let observable_parallax = new IntersectionObserver(
			handler_parallax,
			options_parallax
		);
		let counter = 1;
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element);
			element.dataset.parallaxid = counter;
			counter++;
		});
	}

    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}